<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-flag"></i> Currency</span>
        <el-button
          icon="el-icon-plus"
          style="float: right; padding: 0"
          type="text"
          @click="addCurrency()"
          >Add Currency</el-button
        >
      </div>
      <div class="table-data-projects">
        <data-tables
          v-loading="loading"
          :data="dataTable"
          border
          :page-size="10"
          :pagination-props="{
            background: true,
            pageSizes: [5, 10, 20, 50, 100],
          }"
        >
          <el-table-column
            prop="currency"
            label="Currency"
            header-align="center"
            align="center"
            fixed
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.currency.toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column
            prop="fullname"
            label="Name"
            header-align="center"
            align="center"
            width="300"
          ></el-table-column>
          <el-table-column
            prop="symbol"
            label="Symbol"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="country"
            label="Country"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="provider"
            label="Provider"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="Type"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 'active' ? 'success' : 'info'"
                >{{ scope.row.status }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="uid"
            label="Action"
            header-align="center"
            align="center"
            width="200"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                icon="el-icon-setting"
                type="primary"
                @click="gotoPricing(scope.row.uid)"
                size="mini"
                >Pricing</el-button
              >
              <el-button
                v-if="superRole"
                icon="el-icon-edit"
                type="warning"
                @click="editCurrency(scope.row.uid)"
                size="mini"
                >Edit</el-button
              >
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>
    <currency-add ref="CurrencyAddForm" v-on:submited="getCurrencyList()" />
    <currency-edit ref="CurrencyEditForm" v-on:submited="getCurrencyList()" />
  </div>
</template>

<script>
import { getCurrencyList } from "@/api/currency";
import CurrencyAdd from "./components/currency-add.vue";
import CurrencyEdit from "./components/currency-edit.vue";
export default {
  components: { CurrencyAdd, CurrencyEdit },
  props: {
    project: String,
  },
  computed: {
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
  },
  data() {
    return {
      loading: false,
      dataTable: [],
    };
  },
  methods: {
    getCurrencyList() {
      this.loading = true;
      getCurrencyList(this.project).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.dataTable = data;
        }
      });
    },
    addCurrency() {
      this.$refs.CurrencyAddForm.openDialog(this.project);
    },
    editCurrency(uid) {
      this.$refs.CurrencyEditForm.openDialog(uid);
    },
    gotoPricing(uid) {
      this.$router.push(`?tab=price&currency=${uid}`);
      //  this.$emit('goto-pricing', uid)
    },
  },
  created() {
    this.getCurrencyList();
  },
};
</script>

<style>
</style>